import { Component } from '@angular/core';

@Component({
    selector: 'app-tos',
    templateUrl: './tos.component.html',
    styleUrls: ['./tos.component.css'],
    standalone: false
})
export class TosComponent {

}
